// Screen States
export const SCREEN_STATE_INITIAL = 'SCREEN_STATE_INITIAL';
export const SCREEN_STATE_CONFIRMING = 'SCREEN_STATE_CONFIRMING';

// Options
export const REOPEN_STATEMENT = 'reopen-statement';
export const REMOVE_STATEMENT = 'remove-statement';
